/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { InsiderMappingResponse } from '../models/insider-mapping-response';
import { MappingFilter } from '../models/mapping-filter';
import { MappedInsiderDetail } from '../models/mapped-insider-detail';
import { AsReportedInsider } from '../models/as-reported-insider';
import { InsiderToMap } from '../models/insider-to-map';
import { Insider } from '../models/insider';
@Injectable({
  providedIn: 'root',
})
class InsiderMappingService extends __BaseService {
  static readonly getInsiderMappingPath = '/insiderMapping';
  static readonly getMappedInsidersByIssuerIdPath = '/insiderMapping/mappedInsiders';
  static readonly getInsidersByInsiderNamePath = '/insiderMapping/searchByInsiderName';
  static readonly getInsiderMappingDetailsPath = '/insiderMapping/details/{insiderId}';
  static readonly doMapTheInsiderPath = '/mapInsider';
  static readonly updateInsiderPath = '/mapInsider/update';
  static readonly removeInsiderPath = '/mapInsider/removeInsider';
  static readonly removeAsReportedInsiderPath = '/mapInsider/removeAsReportedInsider';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param mappingFilter undefined
   * @return list of insider mappings
   */
  getInsiderMappingResponse(mappingFilter: MappingFilter): __Observable<__StrictHttpResponse<InsiderMappingResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = mappingFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/insiderMapping`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<InsiderMappingResponse>;
      })
    );
  }
  /**
   * @param mappingFilter undefined
   * @return list of insider mappings
   */
  getInsiderMapping(mappingFilter: MappingFilter): __Observable<InsiderMappingResponse> {
    return this.getInsiderMappingResponse(mappingFilter).pipe(
      __map(_r => _r.body as InsiderMappingResponse)
    );
  }

  /**
   * Returns list of insiders who are already mapped for the given issuer
   * @param params The `InsiderMappingService.GetMappedInsidersByIssuerIdParams` containing the following parameters:
   *
   * - `asReportedIssuerId`: The as-reported issuer ID
   *
   * - `issuerId`: The issuer ID
   *
   * @return List of mapped insiders
   */
  getMappedInsidersByIssuerIdResponse(params: InsiderMappingService.GetMappedInsidersByIssuerIdParams): __Observable<__StrictHttpResponse<Array<MappedInsiderDetail>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.asReportedIssuerId != null) __params = __params.set('asReportedIssuerId', params.asReportedIssuerId.toString());
    if (params.issuerId != null) __params = __params.set('issuerId', params.issuerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/insiderMapping/mappedInsiders`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<MappedInsiderDetail>>;
      })
    );
  }
  /**
   * Returns list of insiders who are already mapped for the given issuer
   * @param params The `InsiderMappingService.GetMappedInsidersByIssuerIdParams` containing the following parameters:
   *
   * - `asReportedIssuerId`: The as-reported issuer ID
   *
   * - `issuerId`: The issuer ID
   *
   * @return List of mapped insiders
   */
  getMappedInsidersByIssuerId(params: InsiderMappingService.GetMappedInsidersByIssuerIdParams): __Observable<Array<MappedInsiderDetail>> {
    return this.getMappedInsidersByIssuerIdResponse(params).pipe(
      __map(_r => _r.body as Array<MappedInsiderDetail>)
    );
  }

  /**
   * @param insiderName undefined
   * @return array of items which are asReportedInsiders
   */
  getInsidersByInsiderNameResponse(insiderName: string): __Observable<__StrictHttpResponse<Array<AsReportedInsider>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (insiderName != null) __params = __params.set('insiderName', insiderName.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/insiderMapping/searchByInsiderName`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AsReportedInsider>>;
      })
    );
  }
  /**
   * @param insiderName undefined
   * @return array of items which are asReportedInsiders
   */
  getInsidersByInsiderName(insiderName: string): __Observable<Array<AsReportedInsider>> {
    return this.getInsidersByInsiderNameResponse(insiderName).pipe(
      __map(_r => _r.body as Array<AsReportedInsider>)
    );
  }

  /**
   * @param insiderId undefined
   * @return array of items which are asReportedInsiders
   */
  getInsiderMappingDetailsResponse(insiderId: number): __Observable<__StrictHttpResponse<Array<AsReportedInsider>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/insiderMapping/details/${encodeURIComponent(String(insiderId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AsReportedInsider>>;
      })
    );
  }
  /**
   * @param insiderId undefined
   * @return array of items which are asReportedInsiders
   */
  getInsiderMappingDetails(insiderId: number): __Observable<Array<AsReportedInsider>> {
    return this.getInsiderMappingDetailsResponse(insiderId).pipe(
      __map(_r => _r.body as Array<AsReportedInsider>)
    );
  }

  /**
   * @param insiderToMap undefined
   * @return it will be return boolean that whether insider was mapped or not.
   */
  doMapTheInsiderResponse(insiderToMap: InsiderToMap): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = insiderToMap;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/mapInsider`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param insiderToMap undefined
   * @return it will be return boolean that whether insider was mapped or not.
   */
  doMapTheInsider(insiderToMap: InsiderToMap): __Observable<boolean> {
    return this.doMapTheInsiderResponse(insiderToMap).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param insiderToUpdate undefined
   * @return it will return a updated insider
   */
  updateInsiderResponse(insiderToUpdate: Insider): __Observable<__StrictHttpResponse<Insider>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = insiderToUpdate;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/mapInsider/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Insider>;
      })
    );
  }
  /**
   * @param insiderToUpdate undefined
   * @return it will return a updated insider
   */
  updateInsider(insiderToUpdate: Insider): __Observable<Insider> {
    return this.updateInsiderResponse(insiderToUpdate).pipe(
      __map(_r => _r.body as Insider)
    );
  }

  /**
   * @param params The `InsiderMappingService.RemoveInsiderParams` containing the following parameters:
   *
   * - `reason`:
   *
   * - `insiderId`:
   *
   * @return it will return a boolean that whether Insider was deleted or not.
   */
  removeInsiderResponse(params: InsiderMappingService.RemoveInsiderParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reason != null) __params = __params.set('reason', params.reason.toString());
    if (params.insiderId != null) __params = __params.set('insiderId', params.insiderId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/mapInsider/removeInsider`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `InsiderMappingService.RemoveInsiderParams` containing the following parameters:
   *
   * - `reason`:
   *
   * - `insiderId`:
   *
   * @return it will return a boolean that whether Insider was deleted or not.
   */
  removeInsider(params: InsiderMappingService.RemoveInsiderParams): __Observable<boolean> {
    return this.removeInsiderResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `InsiderMappingService.RemoveAsReportedInsiderParams` containing the following parameters:
   *
   * - `reason`:
   *
   * - `asReportedInsiderId`:
   *
   * @return it will return a boolean that whether as reported Insider was deleted or not.
   */
  removeAsReportedInsiderResponse(params: InsiderMappingService.RemoveAsReportedInsiderParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reason != null) __params = __params.set('reason', params.reason.toString());
    if (params.asReportedInsiderId != null) __params = __params.set('asReportedInsiderId', params.asReportedInsiderId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/mapInsider/removeAsReportedInsider`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `InsiderMappingService.RemoveAsReportedInsiderParams` containing the following parameters:
   *
   * - `reason`:
   *
   * - `asReportedInsiderId`:
   *
   * @return it will return a boolean that whether as reported Insider was deleted or not.
   */
  removeAsReportedInsider(params: InsiderMappingService.RemoveAsReportedInsiderParams): __Observable<boolean> {
    return this.removeAsReportedInsiderResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module InsiderMappingService {

  /**
   * Parameters for getMappedInsidersByIssuerId
   */
  export interface GetMappedInsidersByIssuerIdParams {

    /**
     * The as-reported issuer ID
     */
    asReportedIssuerId: number;

    /**
     * The issuer ID
     */
    issuerId?: number;
  }

  /**
   * Parameters for removeInsider
   */
  export interface RemoveInsiderParams {
    reason: string;
    insiderId: number;
  }

  /**
   * Parameters for removeAsReportedInsider
   */
  export interface RemoveAsReportedInsiderParams {
    reason: string;
    asReportedInsiderId: number;
  }
}

export { InsiderMappingService }
